import React from 'react';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/lib/ToggleButton';

import styles from './SquareRadio.module.css';
import { FeatureLock } from '../../../common/LockedFeatures';

const SquareRadio = ({ handleSquareRadioChange, valuesList, disabled, radioValue, lightMode, type = 'radio' }) => {
    const radioButtons = valuesList.map((listObj) => {
        const { value, label, disabled = false, onClick } = listObj;

        let classes = `${styles.radioButton}`;
        if ((type === 'radio' && radioValue === value) || (type === 'checkbox' && radioValue.includes(value))) {
            classes += ` ${styles.activeRadioButton}`;
        }

        if (listObj.lockedFeatureOptions) {
            return (
                <FeatureLock
                    key={`squareTooltip_${value}`}
                    displayOptions={listObj.lockedFeatureOptions}
                    className="w-fit max-h-[30px] first:rounded-tr-[4px] first:rounded-br-[4px]:not(:last-child)">
                    <ToggleButton
                        key={`squareRadio_${value}`}
                        className={`${classes} rounded-none max-h-full`}
                        value={value}
                        disabled={disabled}
                        onClick={onClick}>
                        {label}
                    </ToggleButton>
                </FeatureLock>
            );
        }

        return (
            <ToggleButton
                key={`squareRadio_${value}`}
                className={classes}
                value={value}
                disabled={disabled}
                onClick={onClick}>
                {label}
            </ToggleButton>
        );
    });

    return (
        <ToggleButtonGroup
            className={`${styles.squareRadioGroup} ${disabled ? styles.disabled : ''} ${
                lightMode ? styles.lightMode : ''
            }`}
            type={type}
            name="options"
            defaultValue={radioValue}
            value={radioValue}
            onChange={disabled ? () => {} : handleSquareRadioChange}>
            {radioButtons}
        </ToggleButtonGroup>
    );
};

export default SquareRadio;
